export default "__VITE_ASSET__C4fUkxL1__"